export const kbUser = `query {
    kbUserWithRoles{
        firstName
      lastName
      role
      ocplcRole
      email
        roles {
        id
        name
      }
    }
}`